export type WebhookStatusFilter =
  | 'all'
  | 'received'
  | 'processed'
  | 'ignored'
  | 'failed'
  | 'parked';

/**
 * Deutsche Beschriftung der Zustände. `received` steht nicht im Filter, kommt aber in der
 * Tabelle vor — eine Meldung, die eben erst angekommen ist.
 */
const STATUS_LABEL: Record<string, string> = {
  received: 'Angekommen',
  processed: 'Verarbeitet',
  ignored: 'Ignoriert',
  failed: 'Gescheitert',
  parked: 'Zurückgestellt',
};

export function statusLabel(status: string): string {
  return STATUS_LABEL[status] ?? status;
}

/**
 * Die Filterleiste liest ihre Beschriftung aus derselben Tabelle wie die Zeile. Zwei Listen
 * derselben fünf Zustände wären genau die Naht, an der später eine von beiden stehen bleibt.
 */
const FILTER_ORDER: WebhookStatusFilter[] = ['processed', 'parked', 'ignored', 'failed'];

export const webhookStatusOptions: ReadonlyArray<{
  value: WebhookStatusFilter;
  label: string;
}> = [
  { value: 'all', label: 'Alle' },
  ...FILTER_ORDER.map((value) => ({ value, label: statusLabel(value) })),
];

export function statusPillVariant(status: string) {
  switch (status) {
    case 'processed':
      return 'accent' as const;
    case 'failed':
      return 'error' as const;
    case 'ignored':
      return 'outline' as const;
    case 'parked':
      return 'warning' as const;
    case 'received':
    default:
      return 'default' as const;
  }
}

export function formatRaw(raw: string): string {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}
